export default "__VITE_ASSET__DrcFGufl__"